/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */

import { css, html } from "lit";
import { customElement } from "lit/decorators";

import "@maicol07/material-web-additions/data-table/data-table";
import "@maicol07/material-web-additions/data-table/data-table-row";
import "@maicol07/material-web-additions/data-table/data-table-column";
import "@maicol07/material-web-additions/data-table/data-table-cell";

import "@material/mwc-list/mwc-list";
import "@material/mwc-list/mwc-check-list-item";
import "@material/mwc-button";
import "@material/mwc-textfield";
import "@material/mwc-linear-progress";

import "../sub-page-components/hitl-users";
import "../sub-page-components/hitl-consultants";
import "../sub-page-components/hitl-clients";
import { HitlElement } from "../hitl-element";
import { User } from "../data-classes/user";

/**
 * @class HitlAdministration - This component shows the admin page where users (hitl-users), consultants (hitl-consultants.ts) and clients (hitl-clients.ts) can be managed
 * @extends HitlElement
 */
@customElement("hitl-administration")
export class HitlAdministration extends HitlElement {  
    
    static override styles = css`
    .mdc-card > div {
      margin: 0px 12px 0 12px;
    }

    .mdc-card__actions {
      gap: 12px;
    }
  `;

  override async firstUpdated() {
    const accessToken = await this.getAccessToken(true);
    if(this.database)
      this.users =  await User.list(this.database, accessToken);
  }

  override render() {
    return html`
    ${!this.users.find((user) => user.userID == this.userID && user.role == 'DATA-ADMIN')
    ?
    html`<hitl-users
        .dialog=${this.dialog}
        .database=${this.database}
        @get-access-token=${this.getAccessTokenEvent}></hitl-users>`
    :null}
      <hitl-consultants
        .dialog=${this.dialog}
        .database=${this.database}
        .clients=${this.clients}
        .consultants=${this.consultants}
        @get-access-token=${this.getAccessTokenEvent}></hitl-consultants>
      <hitl-clients
        .dialog=${this.dialog}
        .database=${this.database}
        .clients=${this.clients}
        .consultants=${this.consultants}
        @get-access-token=${this.getAccessTokenEvent}></hitl-clients>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "hitl-administration": HitlAdministration;
  }
}
